import { type ReactNode } from 'react'

// The 640px content column every tab renders into, headed by the tab's name.
export function Screen({ title, children }: { children: ReactNode; title: string }) {
  return (
    <div className="flex w-full max-w-[640px] flex-col gap-6 px-4 pt-5 pb-7 md:px-7 md:pt-7 md:pb-9">
      <h1 className="font-semibold text-[22px] text-foreground leading-[1.2] tracking-[-0.3px]">{title}</h1>
      {children}
    </div>
  )
}
